import { createRegistry } from '../registry.js';
/* eslint-enable @typescript-eslint/no-explicit-any */
export const automationBlockRegistry = createRegistry('automation-block-registry', (block) => block.id);
export const defineTrigger = (block) => block;
export const defineCondition = (block) => block;
export const defineAction = (block) => block;
export const isTriggerBlock = (block) => block.kind === 'trigger';
export const isConditionBlock = (block) => block.kind === 'condition';
export const isActionBlock = (block) => block.kind === 'action';
//# sourceMappingURL=block.js.map